import * as React from "react";
import { memo } from "react";

const SvgStandingDesk = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.937 8.189h-4.213v-.906a.276.276 0 0 0-.275-.275h-1.772a.276.276 0 0 0-.275.275v.906h-1.22V6.457h2.48a1.063 1.063 0 0 0 1.063-1.063V1.063A1.063 1.063 0 0 0 13.662 0H6.338a1.063 1.063 0 0 0-1.063 1.063v4.33a1.063 1.063 0 0 0 1.063 1.064h2.48v1.732h-.866v-.906a.275.275 0 0 0-.276-.275H1.378a.276.276 0 0 0-.276.275v.906h-.039a1.063 1.063 0 1 0 0 2.126h.433v9.41c0 .152.124.275.276.275H3.11a.276.276 0 0 0 .276-.276V18.19h7.874v1.535c0 .153.123.276.275.276h1.339a.276.276 0 0 0 .276-.276V18.19h3.464v1.535c0 .153.124.276.276.276h1.338a.276.276 0 0 0 .276-.276v-9.41h.433a1.063 1.063 0 0 0 0-2.125Zm-5.984-.63h1.22v.63h-1.22v-.63ZM5.827 5.394V1.063c0-.283.229-.512.512-.512h7.322c.283 0 .512.23.512.512v4.33c0 .283-.229.512-.511.512H6.338a.512.512 0 0 1-.512-.511ZM9.37 6.457h1.26v1.732H9.37V6.457ZM1.653 7.559h5.749v.63H1.653v-.63Zm1.181 11.89h-.787v-9.134h.787v9.134Zm8.426-9.134v5.984H3.386v-5.984h7.874Zm-7.874 7.323v-.788h7.874v.788H3.386Zm9.212 1.81h-.787v-9.133h.787v9.134Zm4.016-9.133v1.417h-3.465v-1.417h3.465Zm0 3.386h-3.465v-1.418h3.465v1.418Zm-3.465.55h3.465v1.418h-3.465v-1.417Zm0 3.387V16.22h3.465v1.418h-3.465Zm4.804 1.81h-.788v-9.133h.788v9.134Zm.984-9.684H1.063a.512.512 0 0 1 0-1.024h17.874a.512.512 0 0 1 0 1.024Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgStandingDesk);
export default Memo;
